export function createShortName(fullName: string) {
  const nameArray = fullName.split(' ')
  // if (nameArray.length > 1) {
  //   return nameArray[0] + ' ' + nameArray[nameArray.length - 1][0]
  // }

  return nameArray[0]
}
